// L'agent a les mêmes accès que l'admin partout, sauf la gestion des utilisateurs.
export const AGENT_DISALLOWED_PREFIXES = ['/utilisateurs'];

export const getRole = (): string | null => localStorage.getItem('role-bahtb-secret');

export const isAgent = (): boolean => getRole() === 'agent';

export const isPathAllowedForAgent = (pathname: string): boolean =>
  !AGENT_DISALLOWED_PREFIXES.some(p => pathname === p || pathname.startsWith(p + '/'));
